import PopUp from "../../../components/containers/PopUp";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { setProducts } from "../../../server/Product";
import { getBySlug } from "../../../server/Category";
import "./FamilyChangeDialog.scss";
import ReactDOM from "react-dom";

const FamilyChangeDialog = ({
  product,
  close,
  onConfirm,
  markedProducts,
  massage,
  slug,
}) => {
  const dispatch = useDispatch();

  const { products, stationId } = useSelector((state) => ({
    products: state.displayProduct.itemsShow,
    stationId: state.user.stationId,
  }));

  const [selectedProducts, setSelectedProducts] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [familyName, setFamilyName] = useState("");

  useEffect(() => {
    setSelectedProducts(new Set(markedProducts.map((p) => p.productId)));
  }, [markedProducts]);

  useEffect(() => {
    getBySlug(stationId, slug).then((res) => {
      dispatch(setProducts(res.products));
      setFamilyName(res.name);
    });
  }, [dispatch, stationId, slug]);

  const handleProductToggle = (productId) => {
    const newSelected = new Set(selectedProducts);
    if (newSelected.has(productId)) newSelected.delete(productId);
    else newSelected.add(productId);
    setSelectedProducts(newSelected);
    setSelectAll(newSelected.size === products.length);
  };

  const handleSelectAllToggle = () => {
    if (selectAll) {
      setSelectedProducts(new Set());
    } else {
      setSelectedProducts(new Set(products.map((prod) => prod.productId)));
    }
    setSelectAll(!selectAll);
  };

  const handleConfirm = () => {
    if (selectedProducts.size === 0) {
      alert("אנא בחר לפחות מוצר אחד לשינוי");
      return;
    }

    onConfirm(products.filter((prod) => selectedProducts.has(prod.productId)));
    close(false);
  };

  return ReactDOM.createPortal(
    <PopUp width="700px" close={() => close(false)}>
      <div className="family-change-dialog">
        <div className="dialog-header">
          <h3>שינוי מוצרים במשפחה</h3>
          <p>
            מוצר זה שייך למשפחת "
            <span className="category-name">{familyName}</span>
            ".
          </p>
          <p>{massage}</p>
        </div>

        <div className="products-container">
          <div className="select-all-container">
            <label className="product-item select-all">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllToggle}
                className="product-checkbox"
              />
              <span className="product-details">
                <strong>בחר הכל ({products.length} מוצרים)</strong>
              </span>
            </label>
          </div>
          <div className="products-list">
            {products.map((prod) => (
              <label key={prod.productId} className="product-item">
                <input
                  type="checkbox"
                  checked={selectedProducts.has(prod.productId)}
                  onChange={() => handleProductToggle(prod.productId)}
                  className="product-checkbox"
                />
                <span className="product-details">
                  <span className="product-name">{prod.name}</span>
                  {prod.pricing && prod.pricing.price && (
                    <span className="product-price">₪{prod.pricing.price}</span>
                  )}
                </span>
              </label>
            ))}
          </div>
        </div>
        <div className="dialog-actions">
          <button
            className="confirm-button"
            onClick={handleConfirm}
            disabled={selectedProducts.size === 0}
          >
            אישור ({selectedProducts.size} מוצרים נבחרו)
          </button>
          <button className="cancel-button" onClick={() => close(false)}>
            ביטול
          </button>
        </div>
      </div>
    </PopUp>,
    document.body,
  );
};

export default FamilyChangeDialog;
